import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator/index';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles, Grid } from '@material-ui/core';
import { FHETitle, FHEContainerScroll, FHEMiniFormEditButton, FHEContainerForm, FHEItemText, FHEReactSelect } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { SvgTicket } from 'data/common/iconsvg';
import memoizeOne from 'memoize-one';

class FormIssue extends Component {
    static propTypes = {
        sendDataFunc: PropTypes.func.isRequired,
        renderOtherChildren: PropTypes.func,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        ticketLabel: PropTypes.string.isRequired,
        ticketDescription: PropTypes.string.isRequired,
        ticketCreatedAt: PropTypes.string.isRequired,
        ticketCreator: PropTypes.string.isRequired,
        ticketState: PropTypes.string.isRequired,
    };

    static defaultProps = {
        renderOtherChildren: null,
    };
    constructor(props) {
        super(props);
        this.state = {
            formDisabled: true,
            sendLoading: false,
            textInput_error: {},
            formData: this.getDataForm(),
        };
        this.ticketStates = [
            { value: 'new', label: Translator.translate('general.ticketing.new'), disabled: 'true' },
            { value: 'running', label: Translator.translate('general.ticketing.running') },
            { value: 'resolved', label: Translator.translate('general.ticketing.resolved') },
            { value: 'pending', label: Translator.translate('general.ticketing.pending') },
        ];
    }
    getDataForm = () => {
        const { ticketState } = this.props;
        return {
            ticketState: ticketState,
        };
    };

    loadInputs = () => {
        this.setState({
            formDisabled: true,
            sendLoading: false,
            formData: this.getDataForm(),
        });
    };

    handleEdit = () => {
        const { formDisabled } = this.state;

        if (!formDisabled) this.loadInputs();
        this.setState({
            formDisabled: !formDisabled,
            textInput_error: {},
        });
    };

    handleChange = event => {
        const { formData, textInput_error } = this.state;

        this.setState({
            formData: { ...formData, [event.target.name]: event.target.value },
            textInput_error: { ...textInput_error, [event.target.name]: '' },
        });
    };

    confirmEdit = () => {
        const { formData } = this.state;
        const { sendDataFunc } = this.props;

        this.setState({
            formDisabled: false,
            sendLoading: false,
        });
        return sendDataFunc(formData.ticketState)
            .then(() => this.loadInputs())
            .catch(error => {
                this.setState({
                    formDisabled: false,
                    sendLoading: false,
                });
                if (error.validation && error.validation.errors) {
                    return this.handleFormError(error.validation.errors, Translator.translate('ticketsgit.issues.actions.updateError'));
                }
            });
    };

    getSelectedTicketState = memoizeOne(state => {
        return this.ticketStates.find(x => x.value === state);
    });

    handleReactSelect = (event, options) => {
        const { formData } = this.state;

        this.setState({
            formData: { ...formData, [options.name]: event.value },
        });
    };

    render() {
        const { formData, formDisabled, sendLoading } = this.state;
        const {
            history,
            ticketLabel,
            ticketDescription,
            ticketCreatedAt,
            ticketCreator,
            reference,
            profile,
            classes,
            renderOtherChildren,
            homeLabel,
        } = this.props;
        const rightUpdateTicketState =
            profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('fheTicketUpdateState');
        return (
            <Fragment>
                <FHETitle title={ticketLabel} Icon={SvgTicket} />
                <FHEContainerForm>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.home')} itemContent={homeLabel} />
                        </Grid>

                        <Grid container item sm={12} md={6}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.creator')} itemContent={ticketCreator} />
                        </Grid>

                        <Grid container item sm={12} md={6}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.createdAt')} itemContent={ticketCreatedAt} />
                        </Grid>

                        <Grid container item sm={12} md={6}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.ref')} itemContent={reference} />
                        </Grid>

                        <Grid container item sm={12} md={6} className={classes.containerMiniForm}>
                            <FHEMiniFormEditButton
                                handleEdit={this.handleEdit}
                                confirmEdit={this.confirmEdit}
                                sendLoading={sendLoading}
                                formDisabled={formDisabled}
                                hasRightToEdit={rightUpdateTicketState}
                            >
                                <FHEReactSelect
                                    name="ticketState"
                                    label={Translator.translate('general.table.column.status')}
                                    onChange={this.handleReactSelect}
                                    value={this.getSelectedTicketState(formData.ticketState)}
                                    choices={this.ticketStates}
                                    disabled={formDisabled || !rightUpdateTicketState}
                                    isOptionDisabled={option => option.disabled === 'true'}
                                />
                            </FHEMiniFormEditButton>
                        </Grid>

                        <Grid container item sm={12}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.description')} itemContent={ticketDescription} />
                        </Grid>
                    </Grid>
                </FHEContainerForm>
                {renderOtherChildren && renderOtherChildren()}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history, match } = props;
    const ticket = state.environments[history.environment].data.TicketFhe.getIn(['list', match.params.id], new Map());
    const home = state.environments[history.environment].data.Homes.getIn(['list', String(ticket.get('homeId'))], new Map());

    let ticketCreator = ticket.getIn(['creator'], null);
    if (typeof ticketCreator === 'object') {
        ticketCreator = ticketCreator.get('label');
    }

    return {
        profile: state.data.user,
        ticketLabel: ticket.getIn(['label'], null),
        reference: ticket.getIn(['ref'], null),
        ticketDescription: ticket.getIn(['description'], null),
        ticketCreatedAt: ticket.getIn(['createdAt'], null),
        ticketState: ticket.getIn(['state'], null),
        ticketCreator,
        homeLabel: home.get('label'),
    };
}

const styles = theme => ({
    openedColor: {
        color: theme.palette.success.main,
    },
    closedColor: {
        color: theme.palette.error.main,
    },
    loadingContainer: {
        textAlign: 'center',
        margin: 20,
    },
    containerMiniForm: {
        position: 'relative',
    },
});

export default withRouter(renderEnvComponent('scenes/TicketFhe/Form', connect(mapStateToProps)(withStyles(styles, { withTheme: true })(FormIssue))));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/TicketFhe/Form.js